module.exports = __webpack_public_path__ + "static/media/pago_reserva.6c70611c.svg";